import { TOKEN_FLOW, TokenFlowType, TOKEN_FLOW_FAIL } from "../../domain/tokenFlow/index";
import { passwordlessClient } from "../../api/passwordlessClient";
import { QueryResult } from "../../../Common/domain/src/api/queryResult";

// in actions folder
export const startTokenFlowAction = (
  loggedUser: QueryResult
): TokenFlowType => {
  return {
    type: TOKEN_FLOW,
    payload: loggedUser,
  };
};

export const startTokenFlowFailAction = (err: QueryResult): TokenFlowType => {
  return {
    type: TOKEN_FLOW_FAIL,
    payload: err
  };
};

export const handleStartTokenFlow = (token: string) => {
  return function (dispatch: any) {
    const endpoint = new passwordlessClient();
    endpoint
      .userinfo2(token)
      .then((data) => {
        dispatch(startTokenFlowAction(data));
        return data;
      })
      .catch((err) => {
        dispatch(startTokenFlowFailAction(err));
      });
  };
};
